var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.354 8.68704L6.35403 13.687C6.30757 13.7335 6.25242 13.7703 6.19173 13.7955C6.13103 13.8206 6.06598 13.8336 6.00028 13.8336C5.93458 13.8336 5.86953 13.8206 5.80883 13.7955C5.74813 13.7703 5.69298 13.7335 5.64653 13.687C5.60007 13.6406 5.56322 13.5854 5.53808 13.5247C5.51294 13.464 5.5 13.399 5.5 13.3333C5.5 13.2676 5.51294 13.2025 5.53808 13.1418C5.56322 13.0811 5.60007 13.026 5.64653 12.9795L10.2934 8.33329L5.64653 3.68704C5.55271 3.59322 5.5 3.46597 5.5 3.33329C5.5 3.2006 5.55271 3.07336 5.64653 2.97954C5.74035 2.88572 5.8676 2.83301 6.00028 2.83301C6.13296 2.83301 6.26021 2.88572 6.35403 2.97954L11.354 7.97954C11.4005 8.02597 11.4374 8.08112 11.4626 8.14182C11.4877 8.20251 11.5007 8.26758 11.5007 8.33329C11.5007 8.39899 11.4877 8.46406 11.4626 8.52476C11.4374 8.58545 11.4005 8.6406 11.354 8.68704Z",
    fill: "#161616"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.4e99425ddb3d5885eeb22e6fb42ac7cc.svg";
export { ForwardRef as ReactComponent };